import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AccountDetailsPage } from './account-details.page';
import { PagesModule } from '../../pages.module';

const routes: Routes = [
  {
    path: '',
    component: AccountDetailsPage
  }
];

@NgModule({
  imports: [
    PagesModule,
    RouterModule.forChild(routes)
  ],
  declarations: [AccountDetailsPage]
})
export class AccountDetailsPageModule { }
